import type {ComponentExportStructure, ConnectionList, IConnectionItem} from '@wix/document-services-types'
import {getNicknameFromConnectionList} from '@wix/import-export-utils'
import _ from 'lodash'

export const WIX_CODE_CONNECTION_STRUCTURE_PROPERTY_NAME = 'codeName'
export const WIX_CODE_CONNECTION_TYPE = 'WixCodeConnectionItem'
export const WIX_CODE_CONNECTION_LIST_TYPE = 'ConnectionList'

const removeNicknameConnection = (component: ComponentExportStructure): void => {
    const {items} = component.connections as ConnectionList
    // means that we have only nickname connection
    if (items.length === 1) {
        delete component.connections
        return
    }

    _.remove(items, item => item.type === WIX_CODE_CONNECTION_TYPE)
}

export const convertConnectionToCodeName = (component: ComponentExportStructure) => {
    if (component.connections) {
        const nickname = getNicknameFromConnectionList(component.connections.items)

        if (nickname) {
            component[WIX_CODE_CONNECTION_STRUCTURE_PROPERTY_NAME] = nickname
            removeNicknameConnection(component)
        }
    }
}

const createConnectionItem = (nickname: any): IConnectionItem => {
    if (Number.isFinite(nickname)) {
        nickname = nickname.toString()
    }

    return {
        type: WIX_CODE_CONNECTION_TYPE,
        role: nickname
    }
}
const createConnectionList = (): Omit<ConnectionList, 'id'> => {
    return {
        type: WIX_CODE_CONNECTION_LIST_TYPE,
        items: []
    }
}

export const convertCodeNameToConnection = (component: ComponentExportStructure) => {
    const nickname = component[WIX_CODE_CONNECTION_STRUCTURE_PROPERTY_NAME]
    if (nickname) {
        component.connections ??= createConnectionList()
        const {items} = component.connections
        items.push(createConnectionItem(nickname))

        delete component[WIX_CODE_CONNECTION_STRUCTURE_PROPERTY_NAME]
    }
}
